import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Icon from '../../components/icons'
interface props {
  show: boolean,
  onClose: (status: boolean) => void
}

export default function Modal1({ show, onClose }: props) {
  const handleClose = () => {
    onClose(false)
  }

  return (
    <Modal show={show} onHide={handleClose} className="signupModal">
      {/* <Modal.Header closeButton>
        <Modal.Title>Please verify your Email and Phone no</Modal.Title>
      </Modal.Header> */}
      {/* <div className="modal fade bs-example-modal-lg signupModal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"> */}
      {/* <div className="modal-dialog modal-md"> */}
      <div className="modal-content">
        <div className="modal-header border-0 pb-0">
          <div className="d-flex align-items-center justify-content-end w-100 mb-0 pb-0">

            <button type="button" data-dismiss="modal" aria-label="Close" className="close">
              <Icon name='close' onClick={handleClose}/>  
            </button>
          </div>
        </div>
        <div className="modal-body pt-0">
        
          <h2 className="mb-3">Please Verify Your Email</h2>
          

          <div className="form-group m-0 verify_inputctrl">
            <input type="text" className="form-control verify_input" placeholder="info@hotmail.com" />
            <a className="editBtn"><Icon name='edit' /></a>
            <span className="verify_btn">Verify</span>
          </div>
          <p className="mt-3"> We have sent a One-Time Password (OTP) to your registered </p>
          <p>email address: <a href="mailto:info@hotmail.com">info@hotmail.com</a> </p>
          <p>Please retrieve the OTP and enter it in the box below </p>
          <p>
            to complete your verification.
          </p>
          <div className="otp_ctrl">
            <ul>
              <li>
                <input type="password" className="form-control text-center" maxLength={1} />
              </li>
              <li>
                <input type="password" className="form-control text-center" maxLength={1} />
              </li>
              <li>
                <input type="password" className="form-control text-center" maxLength={1} />
              </li>
              <li>
                <input type="password" className="form-control text-center" maxLength={1} />
              </li>
              <li>
                <input type="password" className="form-control text-center" maxLength={1} />
              </li>
              <li>
                <input type="password" className="form-control text-center" maxLength={1} />
              </li>
            </ul>
          </div>



          <div className="d-flex justify-content-center gap-15 mb-3 mt-4">
            <button type="submit" onClick={handleClose} className="btn btn-primary w-md btn-lg px-5 w-100">submit</button>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
    </Modal>
  )
}